import { countryConfigs } from 'kv_import_helpers/scripts/plz/config';

export const availablePLZApiCountryCodes = Object.keys(countryConfigs).reduce(
  (obj, countryCode) => {
    obj[countryCode] = true;
    return obj;
  },
  {} as { [code: string]: boolean },
);
